import React from 'react';
import { Box, Chip, Container, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material'
import { UmrahPaperRequest, UmrahPaperRequestStatus } from '../../../types/UmrahPaperRequest';
import { DateTime } from 'luxon';
import { RunCircleRounded, MopedRounded, CheckCircleRounded, CancelRounded, FiberNewRounded } from '@mui/icons-material';

const getIconFromStatus = (status: UmrahPaperRequestStatus) => {
  if (status === 'Processing') return <RunCircleRounded />;
  else if (status === 'Available') return <MopedRounded />;
  else if (status === 'Completed') return <CheckCircleRounded />;
  else if (status === 'Cancelled') return <CancelRounded />;
  return <FiberNewRounded />;
};

const getColorFromStatus = (status: UmrahPaperRequestStatus) => {
  if (status === 'Processing') return 'warning';
  else if (status === 'Available') return 'secondary';
  else if (status === 'Completed') return 'success';
  else if (status === 'Cancelled') return 'error';
  return 'info';
};

type Props = {
  umrahPaperRequest: UmrahPaperRequest
}
export const UmrahPaperRequestInfoBox = (props: Props) => {
  const { umrahPaperRequest } = props;

  return (
    <Container disableGutters>
      <Box>
        <TableContainer>
          <Table size="small">
            <TableBody>
              <TableRow>
                <TableCell width={250}>Id Number</TableCell>
                <TableCell>{umrahPaperRequest.idNumber}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell width={250}>Name</TableCell>
                <TableCell>{umrahPaperRequest.name}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell width={250}>Date</TableCell>
                <TableCell>{umrahPaperRequest.date ? DateTime.fromISO(umrahPaperRequest.date).toFormat('MMMM dd, yyyy') : ''}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell width={250}>Date Requested</TableCell>
                <TableCell>{DateTime.fromISO(umrahPaperRequest.dateRequested).toFormat('MMMM dd, yyyy — hh:mm:ss a')}</TableCell>
              </TableRow>
              <TableRow sx={{
                '&:last-child td, &:last-child th': { border: 0 } 
              }}>
                <TableCell width={250}>Status</TableCell>
                <TableCell>
                  <Chip 
                    icon={getIconFromStatus(umrahPaperRequest.status)} 
                    label={umrahPaperRequest.status} 
                    color={getColorFromStatus(umrahPaperRequest.status)}
                    variant="outlined" />
                  </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Container>
  );
};
